<template>
  <label class="checkbox" :class="{ checked, disabled }">
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      @change="toggle"
    />

    <span class="box">
      <span v-show="checked" class="icon">
        <slot name="icon">
          <!-- default icon -->
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.06873 10.8214C5.63452 11.2556 4.93052 11.2556 4.49631 10.8214L0.29502 6.62014C-0.0984834 6.22664 -0.0984834 5.58864 0.29502 5.19514C0.688523 4.80164 1.32652 4.80164 1.72002 5.19514L4.96585 8.44098C5.14074 8.61587 5.4243 8.61587 5.59919 8.44098L13.745 0.295142C14.1385 -0.0983607 14.7765 -0.0983613 15.17 0.295142C15.5635 0.688645 15.5635 1.32664 15.17 1.72014L6.06873 10.8214Z" fill="white"/>
          </svg>
        </slot>
      </span>
    </span>

    <span v-if="$slots.default" class="label">
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked () {
      return this.modelValue
    }
  },
  methods: {
    toggle (e) {
      if (this.disabled) return
      this.$emit('update:modelValue', e.target.checked)
    }
  }
}
</script>
<style scoped>
.checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

/* HIDE NATIVE */
.checkbox input {
  display: none;
}

/* BOX */
.box {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e4e7ec;
  background: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;
}

/* CHECKED */
.checkbox.checked .box {
  background: #4c66a4;
  border-color: #4c66a4;
}

/* ICON */
.icon svg {
  width: 16px;
  height: 12px;
  display: block;
}

/* DISABLED */
.checkbox.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.checkbox.disabled .box {
  background: #e4e7ec;
  border-color: #ffffff;
}

/* LABEL */
.label {
  font-size: 14px;
  color: #3c3f44;
}
</style>
